import React, { FC, useRef } from "react";
import {XLg} from "react-bootstrap-icons"
interface Props {
  title?: string;
  subTitle?: string;
  body: JSX.Element | string;
  footer?: JSX.Element | string;
  onClose?: () => void;
  scrollable?: boolean;
  size: "sm" | "lg" | "xl" | "fullscreen";
  customFooter?: boolean; //for no padding full custom footer
  position?: "centered" | "top";
}

export const CustomModal: FC<Props> = ({
  title,
  subTitle,
  body,
  footer,
  onClose,
  scrollable,
  size,
  customFooter,
  position,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  return (
    <React.Fragment>
      <div className={`modal ${size} d-block`} aria-hidden="true">
          <div className="modal-content shadow-lg border-0 rounded ">
            <div className="modal-header border-bottom">
                {title && (
                  <h2 className="text-capitalize">{title}</h2>
                )}
              {onClose && (
                <button
                  type="button"
                  aria-label="Close"
                  className="border rounded"
                  onClick={() => onClose()}
                ><XLg size={20}/></button>
              )}
            </div>
            <div className="modal-body">{body}</div>
            <div className={`${!customFooter && "modal-footer"} border-0`}>
              {footer}
            </div>
          </div>
        </div>
      <div className="modal-backdrop fade show"></div>
    </React.Fragment>
  );
};